<template>
  <div class="row">
    <div class="col-lg">
      <tr>
        <td>
          <!-- if schedule type = cluster, display list of cluster-->
          <div class="col-md" id="type">
            <!-- select which cluster to schedule -->
            <base-input label="Cluster:">
              <el-select
                class="select-primary"
                placeholder="Choose..."
                size="large"
                v-model="selects.multi"
                @change="getHolidayData(selects.multi)"
              >
                <el-option
                  style="color: #000000"
                  v-for="option in selects.clusterList"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label"
                ></el-option>
              </el-select>
            </base-input>
          </div>
        </td>
      </tr>

      <!-- scheduler table -->
      <div class="col-lg-12 col-md" style="padding-top: 10px">
        <h3 class="card-title brightness">
          <div>
            <div
              class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            ></div>
            <!-- :cell-style="tableRowStyle" -->
            <el-table
              :data="holidays"
              v-loading="loading"
              lazy
              :load="editHoliday"
              highlight-current-row
              :header-cell-style="{
                background: 'transparent',
                border: 'transparent',
                'padding-bottom': '0%',
                'padding-center': '10px',
                color: 'white',
              }"
              :cell-style="{
                border: 'transparent',
                'padding-center': '20px',
              }"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column align="right" label="Action">
                <div slot-scope="props">
                  <!-- @click.native="modals.edit = true" -->
                  <el-tooltip content="Edit" placement="bottom" effect="light">
                    <base-button
                      @click="getRowsHoliday(props.$index, props.row)"
                      class="edit btn-link"
                      type="success"
                      size="sm"
                      icon
                      :disabled="disableButton"
                    >
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                  </el-tooltip>
                </div>
                <!-- modal for edit -->
                <modal
                  :show.sync="modals.editholiday"
                  footer-classes="justify-content-center"
                  type="notice"
                >
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-12">
                        <form @submit.prevent>
                          <div class="row justify-content-center mt-12">
                            <div class="col-sm-12">
                              <div>
                                <h3 style="color: #344675">
                                  Scheduler Information
                                </h3>
                                <base-input
                                  v-model="tempIndex"
                                  type="text"
                                  label="No: "
                                  disabled
                                ></base-input>
                                <base-input
                                  v-model="tempHour"
                                  type="text"
                                  label="Hour"
                                  disabled
                                ></base-input>
                                <base-input
                                  v-model="tempMin"
                                  type="text"
                                  label="Min"
                                  disabled
                                ></base-input>
                                <base-input label="On/Off">
                                  <el-select
                                    class="select-success"
                                    size="large"
                                    v-model="tempStatus"
                                    type="text"
                                  >
                                    <el-option
                                      v-for="option in selects.status"
                                      class="select-success"
                                      :value="option.value"
                                      :label="option.label"
                                      :key="option.label"
                                    >
                                    </el-option>
                                  </el-select>
                                </base-input>
                                <base-input label="Brightness">
                                  <el-select
                                    class="select-success"
                                    size="large"
                                    v-model="tempBrightness"
                                    type="text"
                                  >
                                    <el-option
                                      v-for="option in selects.br"
                                      class="select-success"
                                      :value="option.value"
                                      :label="option.label"
                                      :key="option.label"
                                    >
                                    </el-option>
                                  </el-select>
                                </base-input>
                              </div>
                            </div>
                            <div>
                              <base-button
                                class="mt-3"
                                native-type="submit"
                                type="success"
                                @click.native="handleEditHoliday()"
                                >Submit</base-button
                              >
                              <base-button
                                class="mt-3"
                                type="danger"
                                @click.native="modals.editholiday = false"
                                >Cancel</base-button
                              >
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </modal>
              </el-table-column>
            </el-table>
          </div>
        </h3>
      </div>

      <!-- submit scheduler -->
      <div id="button">
        <div id="button_container_1">
          <button
            :disabled="disableButton"
            type="success"
            class="btn btn-success"
            @click="submitHolidays(selects.multi)"
          >
            Submit
          </button>
        </div>
      </div>
    </div>

    <div class="col-lg">
      <!-- scheduler brightness graph -->
      <div class="chart-area">
        <line-chart
          :chart-data="lineChart3.chartData"
          :gradient-colors="lineChart3.gradientColors"
          :gradient-stops="lineChart3.gradientStops"
          :extra-options="lineChart3.extraOptions"
          :height="300"
        ></line-chart>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  TimeSelect,
  DatePicker,
  Select,
  Option,
} from "element-ui";
import { Modal, BasePagination } from "src/components";
import swal from "sweetalert2";
import moment from "moment";
import LineChart from "@/components/Charts/LineChart";
import * as chartConfigs from "@/components/Charts/config";
import config from "@/config";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Option.name]: Option,
    [Select.name]: Select,
    LineChart,
    Modal,
    BasePagination,
  },
  props: ["test"],
  data() {
    return {
      disableButton: true,
      tempIndex: "",
      tempHour: "",
      getRow: "",
      tempMin: "",
      tempStatus: "",
      tempBrightness: "",
      loading: false,
      base64Holiday: [],
      getHoliday: [],
      holidays: [],
      hexDataHoliday: [],
      sendHoliday: [],
      modals: {
        addHolidays: false,
        add: false,
        holidays: false,
        edit: false,
        editweekend: false,
        editholiday: false,
      },
      selects: {
        multi: "",

        clusterList: [],
        device: "",
        devices: [],
        scheType: "multicast",
        hour: "",
        hours: [
          { value: 1, label: "1 a.m." },
          { value: 2, label: "2 a.m." },
          { value: 3, label: "3 a.m." },
          { value: 4, label: "4 a.m." },
          { value: 5, label: "5 a.m." },
          { value: 6, label: "6 a.m." },
          { value: 7, label: "7 a.m." },
          { value: 8, label: "8 a.m." },
          { value: 9, label: "9 a.m." },
          { value: 10, label: "10 a.m." },
          { value: 11, label: "11 a.m." },
          { value: 12, label: "12 p.m." },
          { value: 13, label: "1 p.m." },
          { value: 14, label: "2 p.m." },
          { value: 15, label: "3 p.m." },
          { value: 16, label: "4 p.m." },
          { value: 17, label: "5 p.m." },
          { value: 18, label: "6 p.m." },
          { value: 19, label: "7 p.m." },
          { value: 20, label: "8 p.m." },
          { value: 21, label: "9 p.m." },
          { value: 22, label: "10 p.m." },
          { value: 23, label: "11 p.m." },
          { value: 0, label: "12 a.m." },
        ],
        min: "",
        mins: [
          { value: "0", label: "00" },
          { value: 5, label: "05" },
          { value: 10, label: "10" },
          { value: 15, label: "15" },
          { value: 20, label: "20" },
          { value: 25, label: "25" },
          { value: 30, label: "30" },
          { value: 35, label: "35" },
          { value: 40, label: "40" },
          { value: 45, label: "45" },
          { value: 50, label: "50" },
          { value: 55, label: "55" },
        ],
        status: [
          { value: "On", label: "On" },
          { value: "Off", label: "Off" },
        ],
        br: [
          { value: 10, label: "10" },
          { value: 20, label: "20" },
          { value: 30, label: "30" },
          { value: 40, label: "40" },
          { value: 50, label: "50" },
          { value: 60, label: "60" },
          { value: 70, label: "70" },
          { value: 80, label: "80" },
          { value: 90, label: "90" },
          { value: 100, label: "100" },
        ],
        simple: "",
        brightness: "",
        id: 0,
      },
      tableColumns: [
        {
          prop: "index",
          label: "No:",
        },
        {
          prop: "hour",
          label: "Hour",
          // minWidth: 200
        },
        {
          prop: "min",
          label: "Min",
          // minWidth: 250
        },
        {
          prop: "onoff",
          label: "Status",
          // minWidth: 250
        },
        {
          prop: "brightness",
          label: "Brightness",
          // minWidth: 250
        },
      ],
      lineChart3: {
        chartData: {
          labels: [0, 0, 0, 0, 0, 0, 0],
          datasets: [
            {
              label: "Brightness",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#00f2c3",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
      },
    };
  },
  methods: {
    submitHolidays(clusterID) {
      let a, b, multicastAddr, contype;

      for (var i = 0; i < this.selects.clusterList.length; i++) {
        if (this.selects.clusterList[i].clusterid == clusterID) {
          multicastAddr = this.selects.clusterList[i].multicastid;
      
          contype = this.selects.clusterList[i].conntype;
        }
      }

      for (var i = 0; i < this.holidays.length; i++) {
      
        // convert header to hex
        let hexHeader = (
          "0" + (this.holidays[i].header & 0xff).toString(16)
        ).slice(-2);
       

        // convert profile to hex
        let hexProfile = (
          "0" + (this.holidays[i].profile & 0xff).toString(16)
        ).slice(-2);
       

        //convert index to hex
        let hexIndex = (
          "0" + (this.holidays[i].index & 0xff).toString(16)
        ).slice(-2);
     

        // convert hour to hex
        let hexHour = ("0" + (this.holidays[i].hour & 0xff).toString(16)).slice(
          -2
        );
      

        // convert min to hex
        let hexMin = ("0" + (this.holidays[i].min & 0xff).toString(16)).slice(
          -2
        );
       

        // convert on off to hex
        if (this.holidays[i].onoff === "on") {
          var hexOnOff = "0" + 1;
         
        } else {
          var hexOnOff = "0" + 0;
         
        }

        var hexBrightness =
          "0" + (this.holidays[i].brightness / 10).toString(16);
        // convert brightness to hex

        // arrange all hex value in one var
        var hexValue =
          hexHeader +
          hexProfile +
          hexIndex +
          hexHour +
          hexMin +
          hexOnOff +
          hexBrightness;
     

        // push all hex value in one array
        this.hexDataHoliday.push(hexValue);
      
      }

      // compare 2 array and push change attributes in new array (untuk hantar yang berubah sahaja)
      for (var i = 0; i < this.holidays.length; i++) {
        if (this.hexDataHoliday[i] !== this.getHoliday[i]) {
          this.sendHoliday.push(this.hexDataHoliday[i]);
         
        }
      }

      let CommandList = [];
      // convert data in sendWeekdays to base64
      for (var i = 0; i < this.sendHoliday.length; i++) {
        var base64Value = btoa(
          String.fromCharCode.apply(
            null,
            this.sendHoliday[i]
              .replace(/\r|\n/g, "")
              .replace(/([\da-fA-F]{2}) ?/g, "0x$1 ")
              .replace(/ +$/, "")
              .split(" ")
          )
        );
       
        this.base64Holiday.push(base64Value);
      

        let queue = {
          data: base64Value,
        };

        CommandList.push(queue);
      }

      var urlAPI = ":8003/api/v1/control/light/multicast/" + multicastAddr;

   

      let data = {
        conntype: contype,
        context: "RAW",
        command: CommandList, //array of schedule
      };

    
      this.$http
        .post(urlAPI, data)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            this.message = res.message;
          } else {
            //login OK!
           
            this.message = res.message;
            swal({
              type: "success",
              title: "Changes Submitted!",
            });
          }
        })
        .catch((err) => {
        
          swal({
            type: "error",
            title: "Oops... Something went wrong!",
            text: res.message,
          });
        });

      //hantar haziq
      var urlAPI2 = ":8004/api/v1/session/cluster/" + clusterID;

      let payload2 = {
        type: "HOLIDAYS",
        data: this.hexDataHoliday,
      };

      this.$http
        .put(urlAPI2, payload2)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            this.message = res.message;
          } else {
            //login OK!
          
            this.message = res.message;
            swal({
              type: "success",
              title: "Changes Submitted!",
            });
          }
        })
        .catch((err) => {
       
          swal({
            type: "error",
            title: "Oops... Something went wrong!",
            text: res.message,
          });
        });

   

      this.sendHoliday = [];
      this.hexDataHoliday = [];
      hexValue = "";
      this.getHolidayData(this.selects.multi);
      // this.getWeekdaysData(this.selects.multi)
    },
    editHoliday() {
      

      let newHoliday = {
        header: 5,
        profile: 1,
        index: this.tempIndex,
        hour: this.tempHour,
        min: this.tempMin,
        onoff: this.tempStatus,
        brightness: this.tempBrightness,
      };
      this.holidays[this.tempIndex] = newHoliday;
      this.holidays.splice(this.holidays.length, this.holidays.length);
    
      // for (var i = 0; i < this.weekend.length; i++) {
  
      // }
      this.modals.editholiday = false;
      this.loading = true;
      this.disableButton = false;
    },
    handleEditHoliday() {
      swal({
        title: "Are you sure?",
        text: `You want to edit status: ${this.tempStatus} & brightness: ${this.tempBrightness}`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, edit it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.editHoliday();
          swal({
            title: "Edited!",
            text: `You edited status: ${this.tempStatus} & brightness: ${this.tempBrightness}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
          this.loading = false;
        }
      });
    },
    getRowsHoliday(Index, row) {
      (this.tempIndex = `${row.index}`),
        (this.tempHour = `${row.hour}`),
        (this.tempMin = `${row.min}`),
        (this.tempStatus = `${row.onoff}`),
        (this.tempBrightness = `${row.brightness}`);

      this.modals.editholiday = true;
    },
    getlist() {
      // get list of clusters
      const arr = [];
      this.$http
        .get(":8002/api/v1/manage/cluster")
        .then((res) => {
          if (res.error) {
         
          } else {
            let payload = res.message.cluster_list;

        

            // if array empty, promp error and redirect to create cluster page
            if (payload.length < 1) {
              swal({
                title: "Cluster empty",
                text: "Please create cluster to continue!",
                type: "warning",
                confirmButtonText: "OK",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false,
              }).then(() => {
                this.$router.push("/admin/clustermanagement");
              });
            } else {
              for (let i = 0; i < payload.length; i++) {
                let multicast_array = {
                  value: payload[i].clusterid,
                  label: payload[i].clustername,
                  conntype: payload[i].conntype,
                  clusterid: payload[i].clusterid,
                  multicastid: payload[i].multicastid,
                };

                this.selects.clusterList.push(multicast_array);
              }

              // assign default value to table
              this.selects.multi = this.selects.clusterList[0].clusterid;

              this.getHolidayData(this.selects.multi);
            }
          }
        })
        .catch((err) => {
          
        });
    },
    tableRowStyle({ row, rowIndex }) {
      return "background-color: transparent";
    },
    schedulerBrightnessChart3(data) {

      let timeScheduler = [];
      let brightnessScheduler = [];
      // combine hour and min
      for (var i = 0; i < data.length; i++) {
        let time = data[i].hour + ":" + data[i].min;
       
        timeScheduler.push(time);
        let brightness = data[i].brightness;
      
        brightnessScheduler.push(brightness);
      }
      this.initLine3(timeScheduler, brightnessScheduler);
      timeScheduler = [];
      brightnessScheduler = [];
    },
    initLine3(time, brightness) {
    
      let chartData = {
        datasets: [
          {
            label: "Brightness",
            fill: true,
            borderColor: config.colors.primary,
            borderWidth: 2,
            borderDash: [],
            borderDashOffset: 0.0,
            pointBackgroundColor: config.colors.primary,
            pointBorderColor: "rgba(255,255,255,0)",
            pointHoverBackgroundColor: "#00f2c3",
            pointBorderWidth: 20,
            pointHoverRadius: 4,
            pointHoverBorderWidth: 15,
            pointRadius: 4,
            data: brightness,
          },
        ],
        labels: time,
      };
      this.lineChart3.chartData = chartData;
    },
    getHolidayData(clusterID) {
      // get table data for holidays
    
      const arr = [];
      this.$http
        .get(":8002/api/v1/manage/cluster/" + clusterID)
        .then((res) => {
          if (res.error) {
        
          } else {
         

            let arr = res.message.schedule_info.holidays;
            this.getHoliday = res.message.schedule_info.holidays;
            
            for (var i = 0; i < arr.length; i++) {
              // convert on / off to human readable format
              if (parseInt(arr[i].slice(10, 12), 16) === 0) {
                var onoff = "off";
              } else {
                var onoff = "on";
              }
              parseInt(arr[i].slice(10, 12), 16);
              // slice array to 7 portion and assign to variable
              var my_holiday = {
                header: parseInt(arr[i].slice(0, 2), 16),
                profile: parseInt(arr[i].slice(2, 4), 16),
                index: parseInt(arr[i].slice(4, 6), 16),
                hour: parseInt(arr[i].slice(6, 8), 16),
                min: parseInt(arr[i].slice(8, 10), 16),
                onoff: onoff,
                brightness: parseInt(arr[i].slice(12, 14), 16) * 10,
              };

              this.holidays.push(my_holiday);
              this.charts3.push(my_holiday);
             
              this.schedulerBrightnessChart3(this.charts3);
            }
          }
        })
        .catch((err) => {
          
        });
      // clear array
      this.holidays = [];
      this.charts3 = [];
    },
  },
  mounted() {
    let roleSession = JSON.parse(sessionStorage.getItem("accessList"));

    
    for (var i = 0; i < roleSession.length; i++) {
     
    
      if (roleSession[i] === "cluster.update") {
      
        this.disableButton = true;
        // this.disabledButton = true;
      }
      if (roleSession[i] === "admin.view") {
        this.disableButton = false;
      }
      if (roleSession[i] === "cluster.update") {
        this.disableButton = false;
      }
    }
    this.getlist();
  },
  computed: {},
};
</script>
